<template>
	<app tabbar :create-button="!!createPath" @create="navigateTo(createPath)">
		<tab-list v-model="currentTabIndex" :tab="tabList" @change="updateList"></tab-list>
		<scroll-list ref="list">
			<template v-slot="{data, index}">
				<scroll-item>
					<div class="flex-between-center">
						<div class="name">{{data.bx_type_name}}</div>
						<div class="info"><span :style="{'color': insuranceState[data.state].color}">{{insuranceState[data.state].name}}</span></div>
					</div>
					<div class="info">被保险人：{{data.bbxr_name}}</div>
					<div class="info">项目名称：{{data.project_name}}</div>
					<div class="info">申请时间：{{data.create_date}}</div>
					<button-group slot="button">
						<c-button v-if="data.state == 3 && power('3')" @click="navigateTo('/insurance_detail', {id: data.id})">审批</c-button>
						<c-button v-else color="gray" hollow @click="navigateTo('/insurance_detail', {id: data.id})">查看详情</c-button>
						<c-button v-if="[1,5].includes(data.state) && power('7')" @click="navigateTo('/insurance_apply', {id: data.id})">编辑</c-button>
						<c-button v-else-if="data.state == 2 && power('7')" @click="navigateTo('/insurance_payment', {id: data.id})">上传付款凭证</c-button>
						<c-button v-if="[1,2,5].includes(data.state) && power('7')" color="red" @click="deleteHandle(data, index)">删除</c-button>
					</button-group>
				</scroll-item>
			</template>
		</scroll-list>
	</app>
</template>

<script>
	import {mapGetters} from 'vuex'
	
	export default {
		data() {
			return {
				tabList: [{
					name: '全部'
				}, {
					name: '待审批',
					param: {
						state: 3
					}
				}, {
					name: '已完成',
					param: {
						state: 4
					}
				}, {
					name: '已驳回',
					param: {
						state: 5
					}
				}],
				currentTabIndex: 0
			}
		},
		
		computed: {
			...mapGetters(['power', 'insuranceState']),
			
			createPath() {
				if (this.power('7')) {
					return '/insurance_select';
				}
			}
		},
		
		methods: {
			updateList(data) {
				this.$refs.list.load({
					url: '/project/bx/list',
					data: data.param
				});
			},
			
			deleteHandle(data, index) {
				this.$confirm({
					text: '确定要删除此保单吗？',
					resolve: () => {
						this.request({
							url: '/project/bx/delete',
							data: {
								bx_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.list.delete(index);
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
